import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ProductcartComponent } from './product-cart.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'myIHSAA Store Shopping Cart',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Shopping Cart'}]
    },
	component: ProductcartComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [ProductcartComponent]
})
export class ProductcartModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/ecommerce/product-cart/product-cart.module.ts